import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	addTabTriggerLabel: {
		id: 'navigation-kit-add-tab.add-tab-trigger.add-tab-trigger-label',
		defaultMessage: 'Add to navigation',
		description: 'Tooltip help text for the add tab trigger button.',
	},
});
